<!-- =========================================================================================
    File Name: Home.vue
    Description: Home Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<template>
  <div class="vx-col lg:w-full sm:m-0 m-4" v-if='isEventFetched'>
    <EventInactive v-if='[0,2,3].indexOf(event_status) > -1'></EventInactive>
    <div v-show='[1,3].indexOf(event_status) > -1'>
      <EventConference v-if='isConference'></EventConference>
      <EventParticipants :slug='slug'></EventParticipants>
      <EventVoting v-if='event_status == 1'></EventVoting>
    </div>
    <audio src="@/assets/audio/speech.mp3" id="eventStartAudio" muted/>
  </div>
</template>
<style lang="scss" scoped>
.pull-right {
  float: right;
}

th,
td {
  text-align: left;
  padding: 10px;
}

.btn-link {
  width: 100% !important;
  height: 600px !important;
  background: rgb(71, 70, 70) !important;
  box-shadow: rgb(71, 70, 70) 0px 3px 0px 0px;
}

.vs-dialog {
  max-width: 660px !important;
}

.vs-con-input-label.is-label-placeholder {
  margin-top: 0px !important;
}

.hide-div {
  display: none;
}

@media only screen and (max-width: 992px) {
  .home-card {
    margin-left: 0px;
  }
}

.vs-button-flat,
.vs-button-flat:hover {
  background-color: #7367f0 !important;
  color: #fff !important;
}

.vs-dialog .vs-button {
  margin-right: 20px !important;
  text-align: center;
}

#page-login {
  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1;
    }

    .bg-twitter {
      background-color: #00aaff;
    }

    .bg-google {
      background-color: #4285f4;
    }

    .bg-github {
      background-color: #333;
    }
  }
}

</style>

<script>
import $ from "jquery";
import EventInactive from '../components/event-inactive';
import EventConference from '../components/event-conference';
import EventParticipants from '../components/event-participants';
import EventVoting from '../components/event-voting';
import { mapGetters } from 'vuex';
import EventTypes from '@/utils/event-types';

export default {
  components: {EventInactive, EventConference, EventParticipants, EventVoting},
  data: () => ({
      freeTextValues: [],
      freeTextValuesCheckBoxes: [],
      eventVoting: "",
      userVoting: [],
      current_voting_id: "",
      conference_link: "#",
      external_conference_link: "#",
      ipAddress: "",
      express: [],
      isLoggedInDone: false,
      eventVotingPublish: [],
      checkBox1: [],
      radioBox: [],
      parentIds: [],
      userVotedList: [],
      popupActive2: false,
      userList: [],
      candidates: [],
      options: [],
      candidateResult: [],
      optionResult: [],
      showConference: false,
      delegeted_for: [],
      isSingelVote: [],
      showDelegete: [],
      delegeted: [],
      allVoted: [],
      currentExpressVote: "",
      showCard: [],
      isPlayed: false,
      votedType: [],
      currentVotingType: "",
      customLogo: "",
      customClosedLogo: "",
      diffTime: 0,
      singleDelegatesVoteEnabled: false,
      userInfo: [],
      api:[],
      showIframeDiv: true,
      showChatDiv: "",
  }),
  computed: {
    ...mapGetters([
			'event_listener'
		]),
    slug() {
      return this.$route.params.slug;
    },
    isConference() {
      return EventTypes.findIndex(et => {
        return et.isConference && et.value==this.event_detail.event_type;
      }) > -1;
    },
    isEventFetched() {
      return this.$store.state.event.event_detail ? true : false;
    },
    currentUser() {
      return this.$store.getters.currentUser;
    },
    isSpeaker() {
      const user = this.currentUser;
      return this.participants.findIndex(p => p.user_id == user.id && p.is_speaker == 1) > -1;
    },
    isModerator() {
      return this.$store.state.event.participants
      .findIndex(p => p.user_id == this.currentUser.id && p.is_moderator == 1) > -1;
    },
    event_detail() {
      return this.$store.state.event.event_detail;
    },
    event_status() {
      return this.event_detail.status;
    },
    
    participants() {	
      return this.$store.state.event.participants;	
    },
    is_ghost() {
      if(this.currentUser)
        return this.currentUser.user_role == 'admin';
      return false;
    },
  },
  watch: {
    event_listener: function(listen) {
      if(listen && listen.key=='EventStatus')
        this.getEventStatus();
		}
  },
  mounted() {
    this.getEventId();
    this.userInfo = {
        email: this.currentUser.email,
        displayName:
          this.currentUser.first_name +
          " " +
          this.currentUser.last_name,
      };
  },
  beforeDestroy() {
		this.$store.dispatch('ParticipantLeavePresence', {event_id:this.event_detail.id, clearAll:true});
  },
  methods: {
    getVoteString(data) {
      var str = '';
      if (Array.isArray(data.value)) {
        str = data.value.join(', ');
      } else if (data.value === 1) {
        str = 'Yes';
      } else if (data.value === 2) {
        str = 'No';
      } else if (data.isAbsteined) {
        str = 'Abstained';
      } else {
        str = '---';
      }
      return str;
    },

    /**
     * Get event info
     * @author Madhura Shah
     */
    async getEventId() {
      this.$vs.loading();
      const req = {
        slug: this.slug,
        user_id: this.currentUser.id
      }
      try {
        const res = await this.$store.dispatch("getEventId", req);
        const data = res.data.data;
        if (data.is_invitee) {
          if (data.status == 0) {
            // $('#backgroundAudio')[0].play();
          }
          await this.getParticipants();
          this.getEventStatus();
          this.$store.dispatch('ParticipantJoinPresence', this.event_detail.id);
        }else {
          this.$router.push({path: '/'});
        }

      } catch (error) {
        console.error(error);
        this.$log.error('File : Event.vue | Function : getEventId() | Error :', error);

        // Error response
        this.$vs.notify({
          title: this.$t("EventLoadError"),
          text: error,
          color: "danger",
          position: "top-center"
        });
        return false;
      }
      this.$vs.loading.close();
    },

    async getParticipants() {
      try {
        await this.$store.dispatch("GetEventUsers", this.event_detail.id);
      } catch(error) {
        console.error(error);
        this.$log.error('File : Event.vue | Function : getParticipants() | Error :', error);
        this.$vs.notify({
          title: $t("FailedToLoadData"),
          text: error,
          color: "danger",
          position: "top-center"
        });
      }
    },
    
    /**
     * Get event status (called this function every 5 sec)
     * @author Madhura Shah
     */
    async getEventStatus(end_voting_id = null) {
      try{
        var data = {
          event_id: this.event_detail.id,
          user_id: this.currentUser.id
        };
        const res = await this.$store.dispatch("getEventStatus", data)
      }catch(error){
				console.log(error)
        this.$log.error('File : Event.vue | Function : getEventStatus() | Error :', error);
        this.$vs.loading.close();
        // Error response
        this.$vs.notify({
          title: this.$t("EventInfoError"),
          text: error,
          color: "danger",
          position: "top-center"
        });
      }
    },

    /**
     * Redirect to conf
     * @author Madhura Shah
     */
    redirectToConf() {
      if (this.event_detail.conference_link != null)
        window.location.href = this.event_detail.conference_link;
    },

    /**
     * Voting card no
     * @author Madhura Shah
     */
    words(n) {
      var num = this.$t("VotingNo").split(" ");
      if (n <= 10) return num[n];
      return n;
    }
  },

};
</script>